import React,{useEffect,useState} from 'react';
import styled from 'styled-components';
import { AppState } from '../../store';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { setCurrentCategory, setSubCategoriesStatus,getCategory } from '../../store/categories/functions';
import { fetchFormData, finder } from '../../store/forms/functions';
import { FormData,Form } from '../../store/forms/types';
import {DynamicForm, Card, CardActionButton, DescriptionBox} from './../elements'
import {Signature} from './postItem';

import FormViewItem, { FormViewItemEnum } from '../elements/formViewItem';
type FormItemComponentProps = {
    className?: string,
    match: any,
    onToggleSubCategories: Function,
    onFetchFormData: Function,
    currentCategoryId: number,
    currentCategory: any,
    categories: any,
    currentFormData?: FormData,
    currentForm?: Form
}

const FormItemComponent = (props: FormItemComponentProps) => {
  useEffect(() => {
    props.onFetchFormData(parseInt(""+props.match.params.itemId),parseInt(""+props.match.params.formId));
    return () => {};
  }, [])

  const typeMatcher = (value: string)=>{
    switch (value) {
      case "text": return FormViewItemEnum.Text
      case "textarea": return FormViewItemEnum.TextArea
      case "checkbox": return FormViewItemEnum.CheckBox
      case "select": return FormViewItemEnum.Select
      case "radio": return FormViewItemEnum.Radio
      case "email": return FormViewItemEnum.Email
      case "url": return FormViewItemEnum.Url
      case "image": return FormViewItemEnum.Image
      case "number": return FormViewItemEnum.Number
      case "editor": return FormViewItemEnum.Editor
      default: case "text": return FormViewItemEnum.Text
    }
  }
    return (
        <div className={props.className}>
          {props.currentForm &&
            <Card
              title={props.currentForm.title+": مورد "+props.match.params.itemId}
              headerMeta={<>
                <CardActionButton className="_meta-btn" title="ویرایش" to={`${props.match.url}/edit`} iconClassName="icon-icons8-pencil" hasBorderRight={true}/>
                <CardActionButton className="_meta-btn" title="چاپ" onClick={() => window.print()} hasBorderRight={true}/>
              </>}
            >
              {props.currentFormData && props.currentFormData.items.map(
                (v,k:any)=><FormViewItem key={k} label={""+v.label} value={v.value} type={typeMatcher(v.htmltype)}/>
              )}
              {(props.currentFormData && props.currentFormData.signature) && 
                <Signature signature={props.currentFormData.signature}/>
              }
            </Card>
          }
        </div>
    )
}

const FormItem = styled(FormItemComponent)`
  @media only print {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 10000;
      ._meta-btn{
        display: none;
      }
  }
` 

const mapStateToProps = (state: AppState,ownProps: any) => ({
  categories: state.categories,
  currentCategory: getCategory(state.categories.items,state.categories.currentCategoryId),
  currentCategoryId: state.categories.currentCategoryId,
  currentFormData: findFormData(ownProps.match.params.formId,ownProps.match.params.itemId,state.forms.forms),
  currentForm: findForm(ownProps.match.params.formId,state.forms.forms)
});
function findForm(formId: any,forms: Form[]) {
  if(!formId || !forms) return;
  let formIndex = finder(parseInt(""+formId),forms);
  return forms[formIndex];
}
function findFormData(formId: any,itemId: any,forms: Form[]) {
  if(!formId || !itemId || !forms) return;
  let formIndex = finder(parseInt(""+formId),forms);
  if(formIndex == -1) return;
  let formDataIndex = finder(parseInt(""+itemId),forms[formIndex].formDatas);
  if(formDataIndex == -1) return;
  return forms[formIndex].formDatas[formDataIndex];
}
const mapDispatchToProps = (dispatch:any) => {
    return {
      onToggleSubCategories   : (open: boolean)   =>{
        dispatch(setSubCategoriesStatus(open));
      },
      onFetchFormData: (id: number, formId: number)=>{
        dispatch(fetchFormData(id,formId))
      }
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(FormItem));
